import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { createStyles, FormControlLabel, Radio as MuiRadio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function () {
  return createStyles({
    root: {
      padding: '8px'
    }
  });
});

var Radio = function Radio(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      label = _ref.label,
      name = _ref.name,
      required = _ref.required,
      value = _ref.value;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(FormControlLabel, _extends({
    label: label,
    disabled: disabled
  }, e2e && {
    'data-e2e': e2e
  }, {
    control:
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(MuiRadio, _extends({
      className: classes.root,
      required: required,
      disabled: disabled,
      checked: checked,
      name: name,
      onChange: dsOnChange,
      value: value,
      size: "small",
      color: "primary"
    }, e2e && {
      inputProps: {
        'data-e2e': "".concat(e2e, "-input")
      }
    }))
  }));
};

export default Radio;

try {
  Radio.__docgenInfo = {
    description: '',
    displayName: 'Radio',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<HTMLInputElement>, checked: boolean) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: true,
        type: {
          name: 'ReactNode'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the radio will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      name: {
        defaultValue: null,
        description: 'Name attribute of the `input` element.',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: 'The value of the component. The DOM API casts this to a string.',
        name: 'value',
        required: false,
        type: {
          name: 'unknown'
        }
      },
      checked: {
        defaultValue: null,
        description: 'If `true`, the component is checked.',
        name: 'checked',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the `input` element will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map